<template>
  <NuxtImg
    src="/icons/steamdeck.webp"
    loading="eager"
    style="max-width: 36px"
    alt="steamdeck icon"
    provider="cloudflare"
    preload
  />
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
